import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { offeringsDraftRoute } from '..';

export const offeringsDraftSummaryRoute = createRoute({
  getParentRoute: () => offeringsDraftRoute,
  path: 'summary',
  component: lazyRouteComponent(() => import('./OfferingsDraftSummaryView')),
});
